import { render, staticRenderFns } from "./view.vue?vue&type=template&id=16832654"
import script from "./view.js?vue&type=script&lang=js&external"
export * from "./view.js?vue&type=script&lang=js&external"
import style0 from "./scrollableList.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports